
/**
 * 获取时间戳
 * @param type
 * @return {number}
 */
export function timestamp(type) {
	if (type === 10) {
		const time = new Date().getTime() / 1000
		return Math.ceil(time)
	}
	if (type === 13) {
		return new Date().getTime()
	}
}
/**
 * 时间戳格式化函数
 * @param  {int}    timestamp 要格式化的时间 默认为当前时间
 * @param  {string} format    格式
 * @return {string}           格式化的时间字符串
 * @example formatDate('1350052653', 'Y-m-d')// 2012-10-11
 * @example formatDate('1350052653', 'Y-m-d H:i:s')// 2012-10-12 22:37:33
 */
export function formatDate(timestamp, format) {
	if (format === false) {
		format = 'Y-m-d H:i:s'
	}
	const jsdate = ((timestamp) ? new Date(timestamp * 1000) : new Date())
	const pad = function(n, c) {
		if ((n = n + '').length < c) {
			return new Array(++c - n.length).join('0') + n
		} else {
			return n
		}
	}
	const txt_weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	const txt_ordin = {
		1: 'st', 2: 'nd', 3: 'rd', 21: 'st', 22: 'nd', 23: 'rd', 31: 'st'
	}
	const txt_months = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	const f = {
		//  Day
		d: function() {
			return pad(f.j(), 2)
		},
		D: function() {
			return f.l().substr(0, 3)
		},
		j: function() {
			return jsdate.getDate()
		},
		l: function() {
			return txt_weekdays[f.w()]
		},
		N: function() {
			return f.w() + 1
		},
		S: function() {
			return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th'
		},
		w: function() {
			return jsdate.getDay()
		},
		z: function() {
			return (jsdate - new Date(jsdate.getFullYear() + '/1/1')) / 864e5 >> 0
		},

		//  Week
		W: function() {
			const a = f.z()
			const b = 364 + f.L() - a
			const nd = (new Date(jsdate.getFullYear() + '/1/1').getDay() || 7) - 1
			let nd2 = nd
			if (b <= 2 && ((jsdate.getDay() || 7) - 1) <= 2 - b) {
				return 1
			} else {
				if (a <= 2 && nd >= 4 && a >= (6 - nd)) {
					nd2 = new Date(jsdate.getFullYear() - 1 + '/12/31')
					return date('W', Math.round(nd2.getTime() / 1000))
				} else {
					return (1 + (nd <= 3 ? ((a + nd) / 7) : (a - (7 - nd)) / 7) >> 0)
				}
			}
		},

		//  Month
		F: function() {
			return txt_months[f.n()]
		},
		m: function() {
			return pad(f.n(), 2)
		},
		M: function() {
			return f.F().substr(0, 3)
		},
		n: function() {
			return jsdate.getMonth() + 1
		},
		t: function() {
			let n
			if ((n = jsdate.getMonth() + 1) === 2) {
				return 28 + f.L()
			} else {
				if (n & 1 && n < 8 || !(n & 1) && n > 7) {
					return 31
				} else {
					return 30
				}
			}
		},

		//  Year
		L: function() {
			const y = f.Y()
			return (!(y & 3) && (y % 1e2 || !(y % 4e2))) ? 1 : 0
		},
		// o not supported yet
		Y: function() {
			return jsdate.getFullYear()
		},
		y: function() {
			return (jsdate.getFullYear() + '').slice(2)
		},

		//  Time
		a: function() {
			return jsdate.getHours() > 11 ? 'pm' : 'am'
		},
		A: function() {
			return f.a().toUpperCase()
		},
		B: function() {
			//  peter paul koch:
			const off = (jsdate.getTimezoneOffset() + 60) * 60
			const theSeconds = (jsdate.getHours() * 3600) + (jsdate.getMinutes() * 60) + jsdate.getSeconds() + off
			let beat = Math.floor(theSeconds / 86.4)
			if (beat > 1000) beat -= 1000
			if (beat < 0) beat += 1000
			if ((String(beat)).length === 1) beat = '00' + beat
			if ((String(beat)).length === 2) beat = '0' + beat
			return beat
		},
		g: function() {
			return jsdate.getHours() % 12 || 12
		},
		G: function() {
			return jsdate.getHours()
		},
		h: function() {
			return pad(f.g(), 2)
		},
		H: function() {
			return pad(jsdate.getHours(), 2)
		},
		i: function() {
			return pad(jsdate.getMinutes(), 2)
		},
		s: function() {
			return pad(jsdate.getSeconds(), 2)
		},
		// u not supported yet

		//  Timezone
		// e not supported yet
		// I not supported yet
		O: function() {
			let t = pad(Math.abs(jsdate.getTimezoneOffset() / 60 * 100), 4)
			if (jsdate.getTimezoneOffset() > 0) t = '-' + t
			else t = '+' + t
			return t
		},
		P: function() {
			const O = f.O()
			return (O.substr(0, 3) + ':' + O.substr(3, 2))
		},
		// T not supported yet
		// Z not supported yet

		//  Full Date/Time
		c: function() {
			return f.Y() + '-' + f.m() + '-' + f.d() + 'T' + f.h() + ':' + f.i() + ':' + f.s() + f.P()
		},
		// r not supported yet
		U: function() {
			return Math.round(jsdate.getTime() / 1000)
		}
	}

	let ret = ''

	return format.replace(/[\\]?([a-zA-Z])/g, function(t, s) {
		if (t !== s) {
			//  escaped
			ret = s
		} else if (f[s]) {
			//  a date function exists
			ret = f[s]()
		} else {
			//  nothing special
			ret = s
		}
		return ret
	})
}

/**
 * 获取某年某月有多少天
 * @param year			某年
 * @param month			某月
 * @return {number}		某年某月有多少天
 */
export function getDaysByYearMonth(year, month) {
	month = parseInt(month, 10) + 1
	const date = new Date(year, month, 0)
	return date.getDate()
}

/**
 * 获取当前日期    年月日    20200320
 * @return {string}
 */
export function getNowFormatDate() {
	const date = new Date()
	const separator = '-'
	const year = date.getFullYear()
	let month = date.getMonth() + 1
	let strDate = date.getDate()
	if (month >= 1 && month <= 9) {
		month = '0' + month
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = '0' + strDate
	}
	return year + separator + month + separator + strDate
}
/**
 * 获取当前时间    时:分    06:06
 * @return {string}
 */
export function getNowFormatTime() {
	const date = new Date()
	const separator = ':'
	let hours = date.getHours()
	let minutes = date.getMinutes()
	if (hours >= 1 && hours <= 9) {
		hours = '0' + hours
	}
	if (minutes >= 0 && minutes <= 9) {
		minutes = '0' + minutes
	}
	return hours + separator + minutes
}


// WEBPACK FOOTER //
// ./src/utils/datetime.js